import { Select } from 'antd';
import {memo, useContext, useEffect, useMemo, useState} from "react";
import {getBranch} from "../../../pages/api/hello";
import PaymentContext from "../../../store/PaymentContext";
import {PaymentConst} from "../../../utils/payment";

const PickupBranch = () => {

    const {
        tabActiveStep1,
        sellAdditionalInformation,
        rentAdditionalInformation,
        setRentAdditionalInformation,
        setSellAdditionalInformation,

        sellCustomerError,
        setSellCustomerError,

        rentCustomerError,
        setRentCustomerError,
    } : any = useContext(PaymentContext)

    const additionalInformation = tabActiveStep1 === PaymentConst.TabConst.rent ? rentAdditionalInformation: sellAdditionalInformation;
    const setAdditionalInformation = tabActiveStep1 === PaymentConst.TabConst.rent ? setRentAdditionalInformation: setSellAdditionalInformation;
    const errors = tabActiveStep1 === PaymentConst.TabConst.rent ? rentCustomerError: sellCustomerError;
    const setErrors = tabActiveStep1 === PaymentConst.TabConst.rent ? setRentCustomerError: setSellCustomerError;

    const [options, setOptions] = useState <any>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if(additionalInformation?.branch_name) {
            setOptions([
                {
                    id: additionalInformation?.branch_id,
                    value: additionalInformation?.branch_id,
                    name: additionalInformation?.branch_name,
                    label: additionalInformation?.branch_name
                }
            ])
        }

    }, [tabActiveStep1])

    const fetchData = async () => {
        await setLoading(true)
        const res : any = await getBranch();

        await setOptions(res?.results ?? [])
        await setLoading(false)
    }

    return (
        <div className="box-info p-4 rounded-lg h-full">
            <div className="bold text-lg">Chi nhánh lấy hàng</div>
            <div className="flex gap-2 flex-col mt-1">
                <Select
                    placeholder="Nhập tên chi nhánh"
                    value={ additionalInformation?.branch_id }
                    style={{ width: '100%' }}
                    loading={loading}
                    options={options}
                    fieldNames={{ label: 'name', value: 'id' }}
                    onFocus={fetchData}
                    onChange={(value, option: any) => {
                        setAdditionalInformation({
                            ...additionalInformation,
                            branch_name: option.name,
                            branch_id: option.id,
                        })

                        if(errors?.branch_id) {
                            setErrors({
                                ...errors,
                                branch_id: ''
                            })
                        }

                    }}
                />
                { errors?.branch_id && <span className="color-danger">{ errors.branch_id }</span> }
            </div>
        </div>
    )
}

export default PickupBranch;
